import { Button, Flex, ModalV2 } from "@jsq/ds/core";

type DiscardChangesModalProps = {
  show: boolean;
  title?: string;
  onKeepEditing: () => void;
  onDiscard: () => void;
};

export const DiscardChangesModal = ({
  show,
  title = "Discard changes?",
  onKeepEditing,
  onDiscard,
}: DiscardChangesModalProps) => (
  <ModalV2
    show={show}
    onHide={onKeepEditing}
    title={title}
    size="small"
    isCentered
    data-testid="discard-modal"
    description="If you leave now, your progress will be lost."
  >
    <ModalV2.Body>
      <Flex justifyContent="flex-end" gap={8}>
        <Button variant="neutral" onClick={onKeepEditing} data-testid="keep-editing-btn">
          Keep editing
        </Button>
        <Button variant="danger" onClick={onDiscard} data-testid="discard-btn">
          Discard
        </Button>
      </Flex>
    </ModalV2.Body>
  </ModalV2>
);
